angular.module('dnecom')
    .controller('ProductProcessVariantsController', ["$scope", "$http", "notifications", function ProductProcessVariantsController($scope, $http, notifications) {
        $scope.variants = [];

        var loadVariants = function () {
            $http
                .get(
                    Routing.generate('products_variants_get', {
                        id: $scope.store.id,
                        productId: $scope.product.id
                    })
                )
                .then(function (response) {
                    if (response.data.success) {
                        $scope.variants = response.data.variants;
                        fillQuantity();
                        $scope.$emit('product.variants.appeared', $scope.variants);
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function () {
                    notifications.danger('Request error');
                });
        };

        $scope.$on('product.attributes.changed', loadVariants);
        $scope.$on('avuis:added', loadVariants);
        $scope.$on('avuis:removed', loadVariants);

        $scope.$on('product.beforeSave', function() {
            $scope.product.variants = $scope.variants;
        });

        $scope.$on('product.variants.changed', function($event, value) {
            $scope.variants = value;
            fillQuantity();
            $scope.$emit('product.variants.appeared', $scope.variants);
        });

        let fillQuantity = function () {
            if ($scope.product.quantity) {
                _.each($scope.variants, function (variant) {
                    if (variant.quantity === undefined && variant.id === undefined) {
                        variant.quantity = $scope.product.quantity;
                    }
                });
            }
        };

        $scope.refreshPrices = function () {
            $scope.variants.forEach(function(variant) {
                variant.currentPrice = $scope.product.currentPrice;
                variant.regularPrice = $scope.product.regularPrice;
            });
        }
    }]);
